<template>
<div class="grid">


<template v-if="loading">

<div class="col-12 md:col-6">

<div class="grid">

<div class="col-12">
<Skeleton  height="2.2rem" class="mb-5 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-2"></Skeleton>
</div>




</div>


</div>

<div class="col-12 md:col-6">
<Skeleton  height="18rem" class="mt-3"></Skeleton>
</div>
<!-- line chart --> 
 


</template>






<template v-if="!loading">
<div class="col-12 md:col-6">

<div class="grid">

<div class="col-12">
<template v-if="inputfield.translations.length">
    <h3 class="text-purple-500 mb-0" v-for="translation in inputfield.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">{{translation.translation}}</h3>
</template>
<template v-else>
   <h3 class="text-purple-500 mb-0" >{{inputfield.name}}</h3> 
</template>

</div>

<div class="col-12">

<div class="grid" v-for="selected_readonly_column in selectedreadonlycolumns">
<div class="col-8">
<h4 class="text-primary mb-0 font-bold" >{{getTheTranslation(selected_readonly_column,"translation")}}</h4>
</div>
<div class="col-4">
<h4 class="text-primary mb-0 font-bold" >{{getTheTranslation(selected_readonly_column,"readonly")}}</h4>
</div>
</div>


<div class="grid" v-for="column in inputfield.sorted_columns">
<template v-if="column.translations.length">
    <div class="col-8" v-for="translation in column.translations"  v-show="$store.state.auth.user.preflang_id==translation.language_id"><h4 class="text-primary mb-0">{{translation.translation}}  </h4></div>
</template>
<template v-else>
  <div class="col-8"><h4 class="text-primary mb-0" >{{column.name}}  </h4></div>  
</template>

<div class="col-4"><Tag class="ml-2 mt-4" :value="$filters.numberformat( column.submission_average)" aria-label="Tabable Primary Tag" tabindex="0"></Tag></div>
</div>




</div>

</div>

</div>



<!-- line chart -->	
<div class="col-12 md:col-6">
<Chart type="line" :data="lineData" :options="lineOptions" />
</div>
<!-- line chart -->	




</template>




</div>
</template>

<script>
export default {

  name: 'LineChart',
  props:["inputfield","selectedreadonlycolumns","subdatalenght"],
  mounted()
  {
   
  },
  data () {
    return {
    	loading:true,
    	lineData: {
            labels: [],
                datasets: [
                    {
                        label: null,
                        data: [],
                        fill: false,
                        borderColor: '#7e2f8d',
                        tension: .4
                    },
                ]
            },
            lineOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef'
                        }
                    }
                }
            },
    }
  },
  mounted()
  {
    console.log("linechart")
  },
  methods:{
    getAverage(amount)
    {
        //subdatalenght
        console.log("getAverage")
        console.log(amount)
        console.log(this.subdatalenght)
        return (amount/this.subdatalenght).toFixed(3)
    },
    async changeBarData(data,labels,datasetlabel)
    {
        console.log("changeBarData")
        console.log(data)
        console.log(labels)
        console.log(datasetlabel)
        this.loading = await true
        this.lineData.datasets[0].data = await data
        this.lineData.datasets[0].label = await datasetlabel
        this.lineData.labels = await labels
        this.loading = await false   
    }
  },
}
</script>

<style lang="css" scoped>
</style>